import React, { FC } from 'react';
import styles from './index.module.less';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DownloadOutlined,
  DownOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';
import { Dropdown, Menu, Space } from 'antd';
import { getFormatTime } from '../../effects/until';

export const ApprovedItem: FC<any> = ({
  label,
  username,
  time,
  auditRemark,
  auditType,
  attachments,
}) => {
  const getConclusion = () => {
    if (auditType == 1) {
      return (
        <div className={styles['approved-result']} style={{ color: '#23B066' }}>
          <CheckCircleOutlined />
          <span className={styles['approved-result-text']}>同意</span>
        </div>
      );
    }
    if (auditType == 0) {
      return (
        <div className={styles['approved-result']} style={{ color: '#E84739' }}>
          <CloseCircleOutlined />
          <span className={styles['approved-result-text']}>不同意</span>
        </div>
      );
    }
    if (auditType == 2) {
      return (
        <div className={styles['approved-result']} style={{ color: '#F98E1C' }}>
          <CheckCircleOutlined />
          <span className={styles['approved-result-text']}>有条件同意</span>
        </div>
      );
    }
    return <></>
  };

  const getComment = () => {
    return auditRemark && <div className={styles['approved-comment']}>{auditRemark}</div>;
  };

  // 下载转为blob下载，防止打开预览
  const downloadClick = (url: string) => {
    const paths = url?.split('/');
    const fileName = paths?.[paths.length - 1];

    window
      ?.fetch(url)
      .then(
        (res) => {
          if (res.status === 200) {
            return res.blob();
          }
          return false;
        },
        (error) => {
          console.log(error);
        },
      )
      .then((blob) => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';
        // 使用获取到的blob对象创建的url
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        // 指定下载的文件名
        a.download = fileName;
        a.click();
        document.body.removeChild(a);
        // 移除blob对象的url
        window.URL.revokeObjectURL(url);
      });
  };

  const getAttachment = () => {
    if (!attachments || attachments.length === 0) {
      return null;
    }
    if (attachments.length === 1) {
      const fileItem = attachments[0];
      return (
        <div className={styles['attachment-one']}>
          <div className={styles['attachment-one-name']}>
            <span onClick={() => downloadClick(fileItem.url)}>
              {fileItem.attachmentName}
            </span>
          </div>
          <span onClick={() => downloadClick(fileItem.url)}>
            <DownloadOutlined style={{ fontSize: '16px' }} />
          </span>
        </div>
      );
    }
    if (attachments.length > 1) {
      const fileItem = attachments[0];
      const otherAtt = attachments.slice(1);
      const items = otherAtt.map((el: any, ind: number) => {
        return {
          key: ind,
          label: (
            <div className={styles['attachment-other']}>
              <span onClick={() => downloadClick(el.url)}>
                {el.attachmentName}
              </span>
              <span onClick={() => downloadClick(el.url)}>
                <DownloadOutlined style={{ fontSize: '16px' }} />
              </span>
            </div>
          ),
        };
      });
      const menu = <Menu items={items} />;
      return (
        <div className={styles['attachment-one']}>
          <Dropdown overlay={menu} className={styles['attachment-one-name']}>
            <div>
              <DownOutlined className={styles['attachment-open']} />
              <span onClick={() => downloadClick(fileItem.url)}>
                {fileItem.attachmentName}
              </span>
            </div>
          </Dropdown>
          <div className={styles['attachment-num']}>
            <PaperClipOutlined style={{ fontSize: '12px' }} />
            {attachments.length}
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className={styles['approved-box']}>
      <div className={styles['approved-head']}>
        <div className={styles['approved-head-name']}>
          <span className={styles['approved-head-name-label']}>
            {label || '评审人'}
          </span>
          <span className={styles['approved-head-name-value']}>{username}</span>
        </div>
        { time && 
        <div className={styles['approved-head-date']}>
          {getFormatTime({ time, format: 'YYYY-MM-DD HH:mm:ss' })}
        </div>
        }
      </div>
      {getConclusion()}
      {getComment()}
      {getAttachment()}
    </div>
  );
};
export default ApprovedItem;
